// extracted by mini-css-extract-plugin
module.exports = {"container":"text-inline-image-section_container___PUph"};